/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getCookieScanning(url) {
        return HttpService.get(
            environment.API_COOKIE_SCANNER_ENDPOINT + '/scan2?url=' + url
        );
    },
    importCookieScanner(payload) {
        return HttpService.post(
            environment.API_COOKIE_SCANNER + '/cookie-management/import',
            payload
        );
    },

    getDomainList() {
        return HttpService.get(environment.API_MY_COMPANY + '/domain-role');
    },

    exportScanner(domainId, type) {
        return HttpService.get(
            environment.API_COOKIE_SCANNER +
                `/cookie-dashboard/${domainId}/export`,
            {
                params: { ...type },
                responseType: 'blob',
            }
        );
    },

    getScannerReport(domainId) {
        return HttpService.get(
            environment.API_COOKIE_SCANNER +
                `/cookie/scanner/report/${domainId}`
        );
    },

    getCookieCategory(domainId) {
        return HttpService.get(
            environment.API_COOKIE_SCANNER +
                `/cookie-management/cookie-category/dropdown/${domainId}`
        );
    },

    getReportList(params) {
        return HttpService.get(
            environment.API_COOKIE_SCANNER + '/cookie/scanner/detail',
            {
                params,
            }
        );
    },

    updateCategory(payload) {
        return HttpService.put(
            environment.API_COOKIE_SCANNER + '/cookie/scanner/detail',
            payload
        );
    },
};
